/*
 *
 * ProfilePage actions
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE, TWO_FA_REQUEST, TWO_FA_SUCCESS, TWO_FA_FAILURE, ENABLE_TWO_FA_REQUEST, ENABLE_TWO_FA_SUCCESS, ENABLE_TWO_FA_FAILURE, DISABLE_TWO_FA_REQUEST, DISABLE_TWO_FA_SUCCESS, DISABLE_TWO_FA_FAILURE, UPDATE_PROFILE_NAME_REQUEST, UPDATE_PROFILE_NAME_SUCCESS, UPDATE_PROFILE_NAME_FAILURE, PROFILE_DELETE_REQUEST, PROFILE_DELETE_FAILURE, PROFILE_DELETE_SUCCESS, } from './constants';
import services from '../../services';
import storageService from '../../utils/storageService';
import { changeLocale } from '../LanguageProvider/actions';
import * as rootActions from '../Root/actions';
var AuthService = services.AuthService, UserService = services.UserService;
export var changePassword = function (currentPassword, newPassword) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: CHANGE_PASSWORD_REQUEST });
                return [4 /*yield*/, AuthService.changePassword({
                        old_password: currentPassword,
                        new_password: newPassword,
                    })];
            case 1:
                _a.sent();
                dispatch({ type: CHANGE_PASSWORD_SUCCESS });
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                switch (err_1.status) {
                    case 403:
                        dispatch({
                            type: CHANGE_PASSWORD_FAILURE,
                            err: 'Current password is incorrect',
                        });
                        break;
                    default:
                        dispatch({
                            type: CHANGE_PASSWORD_FAILURE,
                            err: 'Something went wrong when trying to change password, please try again.',
                        });
                        break;
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var changeLanguage = function (language) { return function (dispatch) {
    storageService.setItem('preferred_language', language);
    dispatch(changeLocale(language));
}; };
export var disableTwoFA = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: DISABLE_TWO_FA_REQUEST });
                return [4 /*yield*/, AuthService.disableTwoFA()];
            case 1:
                _a.sent();
                dispatch({ type: DISABLE_TWO_FA_SUCCESS });
                return [3 /*break*/, 3];
            case 2:
                err_2 = _a.sent();
                dispatch({ type: DISABLE_TWO_FA_FAILURE, err: err_2 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var enableTwoFA = function (code) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: ENABLE_TWO_FA_REQUEST });
                return [4 /*yield*/, AuthService.enableTwoFA(code)];
            case 1:
                _a.sent();
                dispatch({ type: ENABLE_TWO_FA_SUCCESS });
                return [3 /*break*/, 3];
            case 2:
                err_3 = _a.sent();
                dispatch({ type: ENABLE_TWO_FA_FAILURE, err: err_3 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var requestTwoFA = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var twoFASecret, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: TWO_FA_REQUEST });
                return [4 /*yield*/, AuthService.requestTwoFA()];
            case 1:
                twoFASecret = _a.sent();
                dispatch({ type: TWO_FA_SUCCESS, twoFASecret: twoFASecret });
                return [3 /*break*/, 3];
            case 2:
                err_4 = _a.sent();
                dispatch({ type: TWO_FA_FAILURE, err: err_4 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var deleteUser = function (userId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: PROFILE_DELETE_REQUEST });
                return [4 /*yield*/, UserService.deleteUser(userId)];
            case 1:
                _a.sent();
                dispatch({ type: PROFILE_DELETE_SUCCESS });
                return [3 /*break*/, 3];
            case 2:
                err_5 = _a.sent();
                dispatch({ type: PROFILE_DELETE_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var updateProfileName = function (userId, firstName, lastName) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: UPDATE_PROFILE_NAME_REQUEST });
                return [4 /*yield*/, UserService.updateUserName(userId, firstName, lastName)];
            case 1:
                _a.sent();
                dispatch({
                    type: UPDATE_PROFILE_NAME_SUCCESS,
                });
                return [2 /*return*/, dispatch(rootActions.loadUserProfile())];
            case 2:
                err_6 = _a.sent();
                dispatch({
                    type: UPDATE_PROFILE_NAME_FAILURE,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
